exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-radio-group.cap-radio-group-v2 .ant-radio-checked .ant-radio-inner{background-color:#47af46}.ant-radio-group.cap-radio-group-v2 .ant-radio-inner:after{background-color:#fff}.cap-radio-group .cap-radio:not(:last-child){margin-right:24px}.ant-radio-checked .ant-radio-inner{background-color:#47af46}.ant-radio-inner:after{background-color:#fff}\n", ""]);

// exports
